import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'code',
            label: i18n.t('inventory.article_code'),
            sortable: true,
        },
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'toxicity_classification_name',
            label: i18n.t('inventory.toxicity_classification'),
            sortable: true,
            align: 'center',
            minWidth: 150,
        },
        {
            prop: 'article_category_code',
            label: i18n.t('inventory.category_code'),
            sortable: true,
        },
        {
            prop: 'article_category_name',
            label: i18n.t('inventory.article_category'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'supplying_unit_abbreviation',
            label: i18n.t('common_words.symbol'),
            sortable: true,
        },
        {
            prop: 'description',
            label: `${i18n.t('common_words.description')}`,
            sortable: true,
            show: false
        }
    ];
    
    return { tableColumns };
}
export default configTable;